var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "content-con" },
      [
        _c(
          "el-card",
          { staticClass: "employees-card-bottom" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 30 } },
              [
                _c("el-col", { attrs: { span: 14, offset: 5 } }, [
                  _c(
                    "div",
                    { staticClass: "intro-box acea-row row-middle" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-box",
                          attrs: {
                            action: "##",
                            "show-file-list": false,
                            headers: _vm.myHeaders,
                            "http-request": _vm.uploadServerLog,
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "img",
                            attrs: { src: _vm.ruleForm.logo, alt: "" },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "btn acea-row row-center-wrapper" },
                            [_c("i", { staticClass: "iconfont iconbianji3" })]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.enterprise_name)),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.cityVals[0]) +
                              _vm._s(_vm.cityVals[1]) +
                              _vm._s(_vm.cityVals[2]) +
                              _vm._s(_vm.address)
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "panel-box" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "panel-title acea-row row-middle row-between",
                      },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("基本信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            !_vm.isEdit
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-edit",
                                    },
                                    on: { click: _vm.onEdit },
                                  },
                                  [_vm._v("编辑")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isEdit
                              ? _c(
                                  "el-button",
                                  { on: { click: _vm.onCancel } },
                                  [_vm._v("取消")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isEdit
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["info:basic:save"],
                                        expression: "['info:basic:save']",
                                      },
                                    ],
                                    attrs: { type: "primary" },
                                    on: { click: _vm.handleSubmit },
                                  },
                                  [_vm._v("保存")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "panel-content" },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "ruleForm",
                            attrs: { model: _vm.ruleForm, rules: _vm.rules },
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 30 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "企业名称",
                                          prop: "enterprise_name",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isEdit,
                                              expression: "isEdit",
                                            },
                                          ],
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "setting.info.title1"
                                            ),
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.ruleForm.enterprise_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "enterprise_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.enterprise_name",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.isEdit,
                                                expression: "!isEdit",
                                              },
                                            ],
                                            staticClass: "value",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ruleForm.enterprise_name
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "企业简称",
                                          prop: "short_name",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isEdit,
                                              expression: "isEdit",
                                            },
                                          ],
                                          attrs: {
                                            maxlength: 6,
                                            placeholder: "请填写企业简称",
                                            "show-word-limit": "",
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.ruleForm.short_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "short_name",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.short_name",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.isEdit,
                                                expression: "!isEdit",
                                              },
                                            ],
                                            staticClass: "value",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.ruleForm.short_name)
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 30 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "setting.info.enterprisecity"
                                          ),
                                        },
                                      },
                                      [
                                        _c("el-cascader", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isEdit,
                                              expression: "isEdit",
                                            },
                                          ],
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            options: _vm.cityData,
                                            props: {
                                              value: "label",
                                              label: "label",
                                            },
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.cityVal,
                                            callback: function ($$v) {
                                              _vm.cityVal = $$v
                                            },
                                            expression: "cityVal",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.isEdit,
                                                expression: "!isEdit",
                                              },
                                            ],
                                            staticClass: "value",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.cityVal[0]) +
                                                " - " +
                                                _vm._s(_vm.cityVal[1]) +
                                                " - " +
                                                _vm._s(_vm.cityVal[2])
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "setting.info.businessaddress"
                                          ),
                                          prop: "address",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isEdit,
                                              expression: "isEdit",
                                            },
                                          ],
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "setting.info.title2"
                                            ),
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.ruleForm.address,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "address",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.address",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.isEdit,
                                                expression: "!isEdit",
                                              },
                                            ],
                                            staticClass: "value",
                                          },
                                          [_vm._v(_vm._s(_vm.ruleForm.address))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 30 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "setting.info.contactnumber"
                                          ),
                                          prop: "phone",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isEdit,
                                              expression: "isEdit",
                                            },
                                          ],
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "setting.info.title3"
                                            ),
                                            clearable: "",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.ruleForm.phone,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "phone",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.phone",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.isEdit,
                                                expression: "!isEdit",
                                              },
                                            ],
                                            staticClass: "value",
                                          },
                                          [_vm._v(_vm._s(_vm.ruleForm.phone))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "panel-box", class: { gray: _vm.isEdit } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "panel-title acea-row row-middle row-between",
                        },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("企业信息"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "panel-content" },
                        [
                          _c(
                            "el-form",
                            { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 30 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "企业成员" } },
                                        [
                                          _c("div", { staticClass: "value" }, [
                                            _vm._v(
                                              _vm._s(_vm.pageData.enterprises) +
                                                "个成员"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "企业部门" } },
                                        [
                                          _c("div", { staticClass: "value" }, [
                                            _vm._v(
                                              _vm._s(_vm.pageData.frames) +
                                                "个部门"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { attrs: { gutter: 30 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "创建人" } },
                                        [
                                          _c("div", { staticClass: "value" }, [
                                            _vm._v(_vm._s(_vm.pageData.lead)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "企业状态" } },
                                        [
                                          _c("div", { staticClass: "value" }, [
                                            _vm.pageData.status == 0
                                              ? _c(
                                                  "span",
                                                  { staticClass: "txt" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "setting.info.disabled"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.pageData.status == 1
                                              ? _c(
                                                  "span",
                                                  { staticClass: "txt" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "setting.info.normal"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.pageData.status == 2
                                              ? _c(
                                                  "span",
                                                  { staticClass: "txt" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "setting.info.behalfpayment"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.pageData.status == 3
                                              ? _c(
                                                  "span",
                                                  { staticClass: "txt" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "setting.info.expired"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }